import { Component, Input } from '@angular/core';
import { ViewCompanyComponent } from 'components/company/viewcompany.component';
import { ListOrdersComponent } from 'components/sale/orders/list-orders.component';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';

@Component({
	selector: 'company-orders',
	templateUrl: './company-orders.component.html',
	imports: [Layout, ListOrdersComponent, TranslatePipe]
})
@ComponentUrl('company-orders')
export class CompanyOrdersComponent {

	private _companyId?: string;

	@UrlParam @Input()
	set companyId(id: string | undefined) {
		this._companyId = id;
		if (id) this.navigation.openNavigationView(this, 'company-related-views', ViewCompanyComponent).then(viewCompany => { viewCompany.companyId = id });
	}
	get companyId() {
		return this._companyId;
	}

	constructor(private readonly navigation: NavigationService) {}
}
